/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TimeZoneEnum {
    EuropePrague = 'Europe/Prague',
    EuropeLondon = 'Europe/London',
    AmericaNewYork = 'America/New_York',
    AmericaLosAngeles = 'America/Los_Angeles',
    AsiaTokyo = 'Asia/Tokyo',
    Utc = 'UTC'
}

export function TimeZoneEnumFromJSON(json: any): TimeZoneEnum {
    return TimeZoneEnumFromJSONTyped(json, false);
}

export function TimeZoneEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeZoneEnum {
    return json as TimeZoneEnum;
}

export function TimeZoneEnumToJSON(value?: TimeZoneEnum | null): any {
    return value as any;
}

